import { Box, Divider, FlexLayout, H4, Icon, Text } from '@deity/falcon-ui';
import type { FC } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

interface IDashBoardBlock {
  itemTitle: string;
  itemsInversion: string | undefined;
  to: string;
  icon: string;
}

const DashboardBlock: FC<IDashBoardBlock> = ({ itemTitle, itemsInversion = 0, to, icon }) => {
  const { url } = useRouteMatch();

  return (
    <Box
      ml="sm"
      mr="sm"
      bg="white"
      boxShadow="subtle"
      style={{ border: 'border: 1px solid #F5F5F5', borderRadius: '4px', flexGrow: 1, maxWidth: '285px' }}
    >
      <Link to={`${url}/${to}`} style={{ textDecoration: 'none', color: 'black' }}>
        <FlexLayout p="md" pt="sm" pb="sm" alignItems="center">
          <Icon
            src={icon}
            color="primary"
            stroke="transparent"
            style={{ height: '26px', width: '26px', opacity: 0.7 }}
          />
          <H4 ml="xs" fontWeight="bold" fontSize="lg">
            {itemTitle}
          </H4>
        </FlexLayout>
        <Divider />
        <FlexLayout p="md" flexDirection="column">
          <Text fontSize="lg" mb="xs">
            {itemsInversion} {itemTitle} used
          </Text>
          <Box style={{ textDecoration: 'none', marginLeft: 'auto', marginTop: '18px', color: '#5E56D2' }}>
            {`-> View ${itemTitle}`}
          </Box>
        </FlexLayout>
      </Link>
    </Box>
  );
};

export default DashboardBlock;
